<template>
  <!-- 分类选择组件 -->
  <div class="yxtbiz-category-selector">
    <yxt-popover
      ref="dropdown"
      v-model="visible"
      custom-elm
      trigger="click"
      placement="bottom-start"
      popper-class="yxtbiz-category-selector-pop"
      :visible-arrow="false"
      :width="width"
    >
      <!-- 多选 -->
      <yxt-select
        slot="reference"
        :disabled="disabled"
        v-if="multiple"
        v-model="checkedList"
        :multiple="multiple"
        :placeholder="placeholder"
        :clearable="clearable"
        collapse-tags
        collapse-tags-auto
        hidden-option
        value-key="nodeId"
        prop-label="nodeName"
        @remove-tag="removeTag"
        :multipleLimit="limit"
        @clear="clearChecked"
        :hide-on-click="false"
      ></yxt-select>
      <!-- 单选 -->
      <yxt-select
        v-else
        slot="reference"
        :clearable="clearable"
        v-model="selected"
        :placeholder="placeholder"
        @clear="handleSelected"
        :multiple="multiple"
        collapse-tags
        collapse-tags-auto
        hidden-option
        value-key="nodeId"
        prop-label="nodeName"
        :hide-on-click="false"
      ></yxt-select>
      <div style="padding: 24px;">
        <!-- 多选树 -->
        <yxtbiz-category-tree
          ref="tree"
          :apiName="apiName"
          style="width: 100%;height:400px;"
          :firstModifiable="false"
          :modifiable="{ add: false, delete: false, modify: false }"
          :code="code"
          :type="type"
          :navCode="navCode"
          :dataPermissionCode="dataPermissionCode"
          v-if="multiple"
          :sortable="false"
          :multiple="multiple"
          :checkedIds="checkedList.map(i => i.nodeId)"
          @addChecked="addChecked"
          @removeChecked="removeChecked"
          :placeholder="searchPlaceholder"
          :limit="limit"
        ></yxtbiz-category-tree>
        <!-- 单选树 -->
        <yxtbiz-category-tree
          :disabledLast="disabledLast"
          :apiName="apiName"
          style="width: 100%;height:400px;"
          :placeholder="searchPlaceholder"
          :type="type"
          ref="tree"
          :firstModifiable="false"
          :modifiable="{ add: false, delete: false, modify: false }"
          :code="code"
          v-else
          :navCode="navCode"
          :dataPermissionCode="dataPermissionCode"
          :sortable="false"
          :multiple="multiple"
          :selectedId="selected ? selected.nodeId : ''"
          @select="handleSelected"
        ></yxtbiz-category-tree>
      </div>
    </yxt-popover>
  </div>
</template>

<script>
import { getNodeDeatil } from './service';
import { http } from 'yxt-biz-pc/packages/api';
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
export default {
  name: 'YxtbizCategorySelector',
  data() {
    return {
      checkedList: [],
      selected: null,
      selectWidth: 200,
      animation: 'yxt-zoom-in-top',
      visible: false,
      options: { boundariesElement: '', gpuAcceleration: false },
      apiInstance: null
    };
  },
  props: {
    value: {},
    apiName: {
      type: String,
      default: 'dmp'
    },
    dropdownWidth: {
      type: Number,
      default: 0
    },
    code: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 100
    },
    navCode: {
      type: String
    },
    dataPermissionCode: {
      type: String
    },
    type: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledLast: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: () => i18n.t('biz_pc_cate_pl').d('请选择分类')
    },
    searchPlaceholder: {
      type: String,
      default: () => i18n.t('biz_pc_search_pl').d('请输入关键字搜索')
    }
  },
  computed: {
    bindString() {
      return !this.multiple && typeof this.value === 'string';
    },
    // 弹出框最小宽度440（减去padding24*2）
    width() {
      const width = this.dropdownWidth ? this.dropdownWidth : this.selectWidth;
      return width;
    }
  },
  async created() {
    this.apiInstance = http[this.apiName];
    await this.init();
  },
  mounted() {
    try {
      if (!this.dropdownWidth) {
        const { width } = this.$el.getBoundingClientRect();
        this.selectWidth = width;
      }
    } catch (e) {}
  },
  watch: {
    value() {
      this.init();
    },
    visible(v) {
      this.$emit('visible-change', v);
    }
  },
  methods: {
    async init() {
      if (this.multiple) {
        this.checkedList = this.value || [];
      } else {
        if (!this.value) return;
        if (this.bindString) {
          // 兼容仅绑定id的情况
          this.selected = {
            nodeId: this.value
          };
          const node = await getNodeDeatil(
            {
              treeId: this.code,
              nodeId: this.value
            },
            this.apiInstance
          );
          this.$set(this.selected, 'nodeName', node.name);
        } else {
          this.selected = this.value;
          this.$set(this.selected, 'nodeName', this.value.nodeName);
        }
      }
    },
    clearChecked() {
      this.checkedList = [];
      this.handleChecked(this.checkedList);
    },
    addChecked(ele) {
      this.checkedList.push({
        nodeName: ele.nodeName,
        nodeId: ele.nodeId
      });
      this.handleChecked(this.checkedList);
    },
    removeChecked(node) {
      let index = this.checkedList.findIndex(i => i.nodeId === node.nodeId);
      index > -1 && this.checkedList.splice(index, 1);
      this.handleChecked(this.checkedList);
    },
    handleSelected(v) {
      if (v) {
        this.selected = v;
        this.$emit('input', this.bindString ? v.nodeId : v);
        this.$emit('change', v);
      } else {
        this.$emit('input', this.bindString ? '' : {});
        this.$emit('change', {});
      }
      this.visible = false;
    },
    handleChecked(v) {
      this.$emit('input', v);
      this.$emit('change', v);
    },
    removeTag(tag) {
      this.$refs.tree && this.$refs.tree.handleCheck(false, tag, 0);
      this.handleChecked(this.checkedList);
    }
  }
};
</script>
